// core
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'open-tile-toggle',
  templateUrl: './open-tile-toggle.component.html',
  styleUrls: ['./open-tile-toggle.component.scss']
})
export class OpenTileToggleComponent implements OnInit {
  @Input() question: any;
  @Input() form: any;
  @Input() isDisabled!: boolean;

  questionControl: any;

  constructor() { }

  ngOnInit(): void {
    this.questionControl = this.form.get(this.question.key);
  }

  get fieldValue() {
    return this.questionControl.value;
  }

  public playAnimation(option: any) {
    let that = this;

    if (
      this.question.settings &&
      this.question.settings.icon_type === 'animation'
    ) {
      this.question.settings.choices.forEach((choice: any) => {
        let player: any = document.querySelector('lottie-player.' + choice.value);
        if (player) {
          if (this.question.type === 'choice') {
            choice.value === option.value ? player.play() : player.stop();
          }
          if (this.question.type === 'multiple_choice') {
            this.questionControl.value[choice.value] === true ? player.play() : player.stop();
          }
        }
      });
    }
  }

}
